import classnames from 'classnames';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import type { Props as IconButtonProps } from '#src/atoms/buttons/IconButton/index.tsx';
import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { iconX } from '#src/atoms/icons/system/iconX.ts';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  onClose: (...args: any[]) => any;
  fixed?: boolean;
  transparent?: boolean;
  menu?: boolean;
} & Omit<IconButtonProps, 'color' | 'classes'>;

const Root = styled(IconButton)`
  position: sticky;
  &.pinned {
    position: absolute;
    top: var(--double-unit);
    right: var(--double-unit);
    z-index: 10;
    &.menu {
      top: var(--unit);
      right: var(--unit);
    }
  }
`;

export const CloseButton = (props: Props) => {
  const { formatMessage } = useIntl();
  const {
    onClose,
    fixed,
    menu,
    transparent = false,
    className,
    ...rest
  } = props;

  return (
    <Root
      {...rest}
      color={transparent ? 'transparent' : 'tertiary'}
      icon={iconX}
      onClick={onClose}
      className={classnames(
        {
          pinned: fixed,
          menu,
        },
        className
      )}
      aria-label={formatMessage(glossary.close)}
    />
  );
};
